import * as React from "react";
import "./offerExtraBorders.css";
export function OfferEtraBorders(props) {
    if (!props.alignment) {
        return React.createElement("div", { className: "order-extra-customization-container" });
    }
    return (React.createElement("div", { className: "order-extra-customization-container" }, props.resources.map((resource, index) => resource.metadata.alignment == props.alignment ?
        React.createElement("div", { key: index, className: "order-extra-customization-box", onClick: () => props.onChoosed(index) },
            React.createElement("img", { src: resource.url, loading: "lazy", height: "160" }))
        : null)));
}
